import React, { FC } from 'react'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Grid,
  Stack,
  Text,
} from '@chakra-ui/react'
import styled from 'styled-components'
import { SuccessIcon } from 'src/icons'

interface Props {
  title: string
  includedLabel: string
  items: Array<string>
}

const IconContainer = styled.span`
  & svg {
    display: inline;
    margin-bottom: -4px;
  }

  & span {
    display: none;
  }

  @media screen and (min-width: 48em) {
    & span {
      margin-left: 4px;
      display: inline-block;
    }
  }
`

const Column: FC<Props> = ({ title, includedLabel, items }) => {
  return <Accordion
    allowToggle allowMultiple
    defaultIndex={[0]}
    bgColor="baseWhite"
    w={{ md: '55.688rem', sm: '100%' }}
    marginLeft={{ md: 'auto !important', base: '20px !important' }}
    marginRight={{ md: 'auto !important', base: '20px !important' }}
  >
    <AccordionItem border="1px solid #d9dde1 !important">
      <h2>
        <AccordionButton p="m" mx="m" _hover={{ background: 'none' }} _active={{ background: 'none' }}>
          <Box
            flex="1"
            textAlign="left"
            fontSize="1rem"
            fontFamily="Montserrat-SemiBold"
            textTransform="uppercase"
          >
            {title}
          </Box>
          <AccordionIcon mx="l" fontSize="30px" />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <Stack align="flex-start" mx="m">
          {items &&
            items.map(item => (
              <Grid
                key={item}
                templateColumns="4fr 1fr"
                w="100%"
                py="m"
                className="accordion-item-mobile-bordered"
              >
                <Text
                  fontFamily="Montserrat-Medium"
                  fontSize="0.875rem"
                  letterSpacing=".2px"
                  color="baseDark"
                  textAlign="left"
                >
                  {item}
                </Text>
                <IconContainer>
                  <Text
                    fontFamily="Montserrat-Medium"
                    fontSize="0.875rem"
                    letterSpacing=".2px"
                    color="baseDark"
                    textAlign="right"
                  >
                    <SuccessIcon />
                    <span>{includedLabel}</span>
                  </Text>
                </IconContainer>
              </Grid>
            ))
          }
        </Stack>
      </AccordionPanel>
    </AccordionItem>
  </Accordion>
}

export default Column
